import React from 'react';
import type { HTMLAttributes, ElementRef } from 'react';

import type { StyleProps } from '@backyard-ui/styles';

import styles from './Popover.styles';

export interface FooterProps
  extends StyleProps<HTMLAttributes<HTMLDivElement>> {}

const PopoverFooter = React.forwardRef<ElementRef<'footer'>, FooterProps>(
  (props, ref) => {
    const { UNSAFE_className, UNSAFE_style, ...rest } = props;

    return (
      <footer
        className={styles().footer({
          className: UNSAFE_className,
        })}
        style={UNSAFE_style}
        ref={ref}
        {...rest}
      />
    );
  }
);

PopoverFooter.displayName = '@backyard-ui/core/PopoverFooter';

export default PopoverFooter;
